import {ResponseChartBox} from './dashboard.interfaces';

export const PAYROLL_STATUS: ResponseChartBox = {
  indexNumber: 1,
  isFake: true,
  cardType: 'PAYROLL_STATUS',
  params: {
    'JULY-2018': [
      {
        name: 'ERROR',
        value: 54,
        link: null
      },
      {
        name: 'FROZEN',
        value: 71,
        link: null
      },
      {
        name: 'DONE',
        value: 15,
        link: null
      },
      {
        name: 'SCHEDULED',
        value: 10,
        link: null
      },
      {
        name: 'TODO',
        value: 21,
        link: null
      }
    ]
  }
};

export const PAYROLL_VALIDATION_PROGRESS: ResponseChartBox = {
  indexNumber: 1,
  isFake: true,
  cardType: 'PAYROLL_VALIDATION_PROGRESS',
  params: {
    JANUARY: [
      {
        name: 'France - Jan 2017 (2017-01-25)',
        value: 16,
        link: null
      },
      {
        name: 'USA - Weeks 1-2 2017 (2017-01-16)',
        value: 100,
        link: null
      },
      {
        name: 'Ireland - Jan 2017 (2017-01-25)',
        value: 56,
        link: null
      },
      {
        name: 'Monaco - Jan 2017 (2017-01-25)',
        value: 100,
        link: null
      },
      {
        name: 'Morocco - Jan 2017 (2017-01-25)',
        value: 98,
        link: null
      },
      {
        name: 'Netherlands - Jan 2017 (2017-01-25)',
        value: 11,
        link: null
      },
      {
        name: 'Luxembourg - Jan 2017 (2017-01-25)',
        value: 45,
        link: null
      }
    ]
  }
};

export const VALIDATION_PLAN_BY_TYPE: ResponseChartBox = {
  indexNumber: 1,
  isFake: true,
  cardType: 'VALIDATION_PLAN_BY_TYPE',
  params: {
    'JULY-2018': [
      {
        name: 'ERROR_TECHNIC',
        value: 54,
        link: null
      },
      {
        name: 'INFORMATION',
        value: 71,
        link: null
      },
      {
        name: 'ALERT',
        value: 91,
        link: null
      },
      {
        name: 'WARNING',
        value: 45,
        link: null
      },
      {
        name: 'TAG',
        value: 11,
        link: null
      }
    ]
  }
};

export const VALIDATION_PLAN_BY_FAMILY: ResponseChartBox = {
  indexNumber: 1,
  isFake: true,
  cardType: 'VALIDATION_PLAN_BY_FAMILY',
  params: {
    JANUARY: [
      {
        name: '01.GrossSalary',
        value: 55,
        link: null
      },
      {
        name: 'Technical Error',
        value: 100,
        link: null
      },
      {
        name: '05.WorkingTime',
        value: 25,
        link: null
      },
      {
        name: '06.Other',
        value: 15,
        link: null
      }
    ]
  }
};

export const VACANT_POSITIONS: ResponseChartBox = {
  cardType: 'VACANT_POSITIONS',
  isFake: true,
  indexNumber: 2,
  params: {
    MAY: [
      {
        name: 'CFO',
        value: 8534,
        link: null
      },
      {
        name: 'HR Director',
        value: 8534,
        link: null
      },
      {
        name: 'PA-Payroll Manager',
        value: 8534,
        link: null
      },
      {
        name: 'President & CEO',
        value: 8534,
        link: null
      },
      {
        name: 'Talent Manager',
        value: 8534,
        link: null
      },
      {
        name: 'Test position',
        value: 17665,
        link: null
      },
      {
        name: 'VP Operations Digital',
        value: 8534,
        link: null
      },
      {
        name: 'VP Services',
        value: 8534,
        link: null
      }
    ]
  }
};

export const HIRE_TERMINATION: ResponseChartBox = {
  indexNumber: 6,
  isFake: true,
  cardType: 'HIRE_TERMINATION',
  params: {
    MAY: [
      {
        name: 'Hired',
        value: 5,
        link: null
      },
      {
        name: 'Terminated',
        value: 2,
        link: null
      }
    ],
    MARCH: [
      {
        name: 'Hired',
        value: 4,
        link: null
      },
      {
        name: 'Terminated',
        value: 1,
        link: null
      }
    ],
    APRIL: [
      {
        name: 'Hired',
        value: 6,
        link: null
      },
      {
        name: 'Terminated',
        value: 2,
        link: null
      }
    ]
  }
};

export const TURNOVER: ResponseChartBox = {
  indexNumber: 5,
  isFake: true,
  cardType: 'TURNOVER',
  params: {
    MAY: [
      {
        name: 'Turnover',
        value: 2.04,
        link: null
      }
    ],
    MARCH: [
      {
        name: 'Turnover',
        value: 3.2,
        link: null
      }
    ],
    APRIL: [
      {
        name: 'Turnover',
        value: 1.05,
        link: null
      }
    ]
  }
};

export const CONTRACT_TYPES: ResponseChartBox = {
  indexNumber: 3,
  isFake: true,
  cardType: 'CONTRACT_TYPES',
  params: {
    APRIL: [
      {
        name: 'IsFixedTermContract',
        value: 43,
        link: null
      },
      {
        name: 'AgreementToPerformWork',
        value: 11,
        link: null
      },
      {
        name: 'AgreementAboutStudentTemporaryWork',
        value: 15,
        link: null
      },
      {
        name: 'PermanentContract',
        value: 25,
        link: null
      },
      {
        name: 'ContratDeProfessionnalisation',
        value: 16,
        link: null
      },
      {
        name: 'Internship',
        value: 5,
        link: null
      }
    ]
  }
};

export const TERMINATION_REASONS: ResponseChartBox = {
  indexNumber: 4,
  isFake: true,
  cardType: 'TERMINATION_REASONS',
  params: {
    'SEPTEMBER-2018': [
      {
        name: 'Death',
        value: 1,
        link: null
      }
    ], 'JULY-2018': [
      {
        name: 'Death',
        value: 5,
        link: null
      },
      {
        name: 'Dismissal for business reasons',
        value: 4,
        link: null
      },
      {
        name: 'Mutual Agreement / Settlement',
        value: 1,
        link: null
      }
    ],
    'AUGUST-2018': [
      {
        name: 'Death',
        value: 10,
        link: null
      },
      {
        name: 'Better Opportunity',
        value: 3,
        link: null
      }
    ]
  }
};

export const FTE_AND_HEADCOUNT: ResponseChartBox = {
  indexNumber: 2,
  isFake: true,
  cardType: 'FTE_AND_HEADCOUNT',
  params: {
    JANUARY: [
      {
        name: 'HeadCount',
        value: 128,
        link: null
      },
      {
        name: 'FTE',
        value: 157.1,
        link: null
      }
    ],
    FEBRUARY: [
      {
        name: 'HeadCount',
        value: 158,
        link: null
      },
      {
        name: 'FTE',
        value: 137.1,
        link: null
      }
    ],
    MARCH: [
      {
        name: 'HeadCount',
        value: 158,
        link: null
      },
      {
        name: 'FTE',
        value: 117.1,
        link: null
      }
    ],
    APRIL: [
      {
        name: 'HeadCount',
        value: 118,
        link: null
      },
      {
        name: 'FTE',
        value: 157.1,
        link: null
      }
    ]
  }
};

export const ABSENCES_BY_FAMILY: ResponseChartBox = {
  indexNumber: 1,
  isFake: true,
  cardType: 'ABSENCES_BY_FAMILY',
  params: {
    'next week': [
      {
        name: 'Sickness',
        value: 16,
        link: null
      },
      {
        name: 'Absences',
        value: 3,
        link: null
      }
    ],
    'current week': [
      {
        name: 'Sickness',
        value: 12,
        link: null
      },
      {
        name: 'Absences',
        value: 4,
        link: null
      }
    ],
    'previous week': [
      {
        name: 'Sickness',
        value: 10,
        link: null
      },
      {
        name: 'Absences',
        value: 6,
        link: null
      }
    ]
  }
};

export const CONTRACTS_TO_CHECK: ResponseChartBox = {
  indexNumber: 1,
  isFake: true,
  cardType: 'CONTRACTS_TO_CHECK',
  params: {
    'CONTRACTS_TO_CHECK.all': [
      {
        name: 'Inactive',
        value: 5,
        link: null
      },
      {
        name: 'Active',
        value: 20,
        link: null
      },
      {
        name: 'Futur',
        value: 3,
        link: null
      }
    ],
    'CONTRACTS_TO_CHECK.incomplete': [
      {
        name: 'Inactive',
        value: 3,
        link: null
      },
      {
        name: 'Active',
        value: 10,
        link: null
      },
      {
        name: 'Futur',
        value: 2,
        link: null
      }
    ],
    'CONTRACTS_TO_CHECK.events': [
      {
        name: 'Inactive',
        value: 1,
        link: null
      },
      {
        name: 'Active',
        value: 4,
        link: null
      },
      {
        name: 'Futur',
        value: 0,
        link: null
      }
    ],
    'CONTRACTS_TO_CHECK.alerts': [
      {
        name: 'Inactive',
        value: 1,
        link: null
      },
      {
        name: 'Active',
        value: 6,
        link: null
      },
      {
        name: 'Futur',
        value: 1,
        link: null
      }
    ]
  }
};

export const PAYROLL_INPUT_SYNC_STATUS: ResponseChartBox = {
  indexNumber: 1,
  isFake: true,
  cardType: 'PAYROLL_INPUT_SYNC_STATUS',
  params: {
    'PAYROLL_SYNC_STATUS.active': [
      {name: 'PAYROLL_SYNC_STATUS.compliant', value: 16, link: null},
      {name: 'PAYROLL_SYNC_STATUS.failed', value: 6, link: null},
      {name: 'PAYROLL_SYNC_STATUS.success', value: 31, link: null},
      {name: 'PAYROLL_SYNC_STATUS.in_progress', value: 11, link: null}
    ],
    'PAYROLL_SYNC_STATUS.future': [
      {name: 'PAYROLL_SYNC_STATUS.compliant', value: 11, link: null},
      {name: 'PAYROLL_SYNC_STATUS.failed', value: 3, link: null},
      {name: 'PAYROLL_SYNC_STATUS.success', value: 21, link: null},
      {name: 'PAYROLL_SYNC_STATUS.in_progress', value: 8, link: null}
    ],
    'PAYROLL_SYNC_STATUS.inactive': [
      {name: 'PAYROLL_SYNC_STATUS.compliant', value: 15, link: null},
      {name: 'PAYROLL_SYNC_STATUS.failed', value: 4, link: null},
      {name: 'PAYROLL_SYNC_STATUS.success', value: 25, link: null},
      {name: 'PAYROLL_SYNC_STATUS.in_progress', value: 5, link: null}
    ]
  }
};

export const PERSON_MASTER_DATA_V2_SYNC_STATUS: ResponseChartBox = {
  indexNumber: 1,
  isFake: true,
  cardType: 'PERSON_MASTER_DATA_V2_SYNC_STATUS',
  params: {
    'PAYROLL_SYNC_STATUS.active': [
      {name: 'PAYROLL_SYNC_STATUS.compliant', value: 18, link: null},
      {name: 'PAYROLL_SYNC_STATUS.failed', value: 5, link: null},
      {name: 'PAYROLL_SYNC_STATUS.success', value: 34, link: null},
      {name: 'PAYROLL_SYNC_STATUS.in_progress', value: 9, link: null}
    ],
    'PAYROLL_SYNC_STATUS.future': [
      {name: 'PAYROLL_SYNC_STATUS.compliant', value: 12, link: null},
      {name: 'PAYROLL_SYNC_STATUS.failed', value: 2, link: null},
      {name: 'PAYROLL_SYNC_STATUS.success', value: 19, link: null},
      {name: 'PAYROLL_SYNC_STATUS.in_progress', value: 7, link: null}
    ],
    'PAYROLL_SYNC_STATUS.inactive': [
      {name: 'PAYROLL_SYNC_STATUS.compliant', value: 13, link: null},
      {name: 'PAYROLL_SYNC_STATUS.failed', value: 3, link: null},
      {name: 'PAYROLL_SYNC_STATUS.success', value: 22, link: null},
      {name: 'PAYROLL_SYNC_STATUS.in_progress', value: 6, link: null}
    ]
  }
};

export const PERSON_MASTER_DATA_V3_SYNC_STATUS: ResponseChartBox = {
  indexNumber: 1,
  isFake: true,
  cardType: 'PERSON_MASTER_DATA_V3_SYNC_STATUS',
  params: {
    'PAYROLL_SYNC_STATUS.active': [
      {name: 'PAYROLL_SYNC_STATUS.compliant', value: 20, link: null},
      {name: 'PAYROLL_SYNC_STATUS.failed', value: 4, link: null},
      {name: 'PAYROLL_SYNC_STATUS.success', value: 38, link: null},
      {name: 'PAYROLL_SYNC_STATUS.in_progress', value: 10, link: null}
    ],
    'PAYROLL_SYNC_STATUS.future': [
      {name: 'PAYROLL_SYNC_STATUS.compliant', value: 14, link: null},
      {name: 'PAYROLL_SYNC_STATUS.failed', value: 2, link: null},
      {name: 'PAYROLL_SYNC_STATUS.success', value: 23, link: null},
      {name: 'PAYROLL_SYNC_STATUS.in_progress', value: 6, link: null}
    ],
    'PAYROLL_SYNC_STATUS.inactive': [
      {name: 'PAYROLL_SYNC_STATUS.compliant', value: 17, link: null},
      {name: 'PAYROLL_SYNC_STATUS.failed', value: 3, link: null},
      {name: 'PAYROLL_SYNC_STATUS.success', value: 27, link: null},
      {name: 'PAYROLL_SYNC_STATUS.in_progress', value: 5, link: null}
    ]
  }
};
